export class FeaturesChangedByServer {
   public static readonly type = '[EnabledFeatures] Features changed by Server';

   constructor(public enabledFeatures: string[]) {}
}
